module.exports = __webpack_public_path__ + "img/guohuimian@2x.f1d2363e.png";